import index from './src';

export const resolveToObject = index;

export default {
  resolveToObject,
};
